/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DeliveryBoxIsoIcon16Solid = forwardRef('DeliveryBoxIsoIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.198.89a2.5 2.5 0 0 0-2.396 0l-4.5 2.458a2.498 2.498 0 0 0-.615.473L8 7.294l6.313-3.473a2.496 2.496 0 0 0-.615-.473L9.198.891Z" }),
        React.createElement("path", { d: "M14.92 4.914 8.625 8.376v6.96c.197-.051.39-.127.573-.227l4.5-2.457A2.5 2.5 0 0 0 15 10.458V5.542c0-.214-.028-.425-.08-.628Z" }),
        React.createElement("path", { d: "M7.375 15.336v-6.96L1.08 4.914c-.052.203-.08.414-.08.628v4.916a2.5 2.5 0 0 0 1.302 2.194l4.5 2.457c.183.1.376.176.573.227Z" })));
});
